import { useMemo, useState } from 'react';
import { Search, Sparkles } from 'lucide-react';
import { curriculum } from '../content/curriculum';
import { RevisionCard } from '../components/RevisionCard';

const filters = ['All', 'DSA', 'System Design', 'Career'] as const;

export function RevisionPage() {
  const [filter, setFilter] = useState<(typeof filters)[number]>('All');
  const [query, setQuery] = useState('');
  const lessons = useMemo(() => curriculum.filter((lesson) => {
    const matchesFilter = filter === 'All' || lesson.track === filter;
    const text = `${lesson.title} ${lesson.revision.identifier} ${lesson.revision.bullets.join(' ')}`.toLowerCase();
    return matchesFilter && text.includes(query.trim().toLowerCase());
  }), [filter, query]);

  return (
    <div className="page revision-page">
      <header className="page-heading split"><div><span className="eyebrow">60-SECOND RECALL</span><h1>Quick revision</h1><p>Recognize the signal, remember three rules, move on.</p></div><div className="revision-count"><Sparkles /><span><strong>{lessons.length}</strong><small>topics visible</small></span></div></header>
      <div className="revision-toolbar">
        <label><Search /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search a pattern, signal, or topic…" /></label>
        <div>{filters.map((item) => <button key={item} className={filter === item ? 'active' : ''} onClick={() => setFilter(item)}>{item}</button>)}</div>
      </div>
      {lessons.length ? <div className="revision-grid">{lessons.map((lesson) => <RevisionCard key={lesson.day} lesson={lesson} />)}</div> : <div className="revision-empty"><Search /><h3>No matching revision card</h3><p>Try a broader signal such as “contiguous,” “graph,” or “cache.”</p></div>}
    </div>
  );
}
